import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { Download } from 'lucide-react';
import { Report, ReportFilters } from './types';

interface ReportDialogProps {
  open: boolean;
  onClose: () => void;
  selectedReport: Report | null;
  filters: ReportFilters;
  onFilterChange: (updates: Partial<ReportFilters>) => void;
  onGenerate: () => void;
}

export const ReportDialog: React.FC<ReportDialogProps> = ({
  open,
  onClose,
  selectedReport,
  filters,
  onFilterChange,
  onGenerate,
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {selectedReport?.title}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            {selectedReport?.description}
          </Typography>

          {selectedReport?.filters.includes('dateRange') && (
            <FormControl fullWidth>
              <InputLabel>Date Range</InputLabel>
              <Select
                value={filters.dateRange}
                label="Date Range"
                onChange={(e) => onFilterChange({ dateRange: e.target.value })}
              >
                <MenuItem value="last-30">Last 30 Days</MenuItem>
                <MenuItem value="last-90">Last 90 Days</MenuItem>
                <MenuItem value="last-180">Last 180 Days</MenuItem>
                <MenuItem value="last-365">Last Year</MenuItem>
                <MenuItem value="custom">Custom Range</MenuItem>
              </Select>
            </FormControl>
          )}

          {selectedReport?.filters.includes('practiceArea') && (
            <FormControl fullWidth>
              <InputLabel>Practice Area</InputLabel>
              <Select
                value={filters.practiceArea}
                label="Practice Area"
                onChange={(e) => onFilterChange({ practiceArea: e.target.value })}
              >
                <MenuItem value="all">All Practice Areas</MenuItem>
                <MenuItem value="personal-injury">Personal Injury</MenuItem>
                <MenuItem value="family-law">Family Law</MenuItem>
                <MenuItem value="corporate">Corporate Law</MenuItem>
                <MenuItem value="real-estate">Real Estate</MenuItem>
                <MenuItem value="criminal">Criminal Defense</MenuItem>
              </Select>
            </FormControl>
          )}

          {selectedReport?.filters.includes('attorney') && (
            <FormControl fullWidth>
              <InputLabel>Attorney</InputLabel>
              <Select
                value={filters.attorney}
                label="Attorney"
                onChange={(e) => onFilterChange({ attorney: e.target.value })}
              >
                <MenuItem value="all">All Attorneys</MenuItem>
                <MenuItem value="1">John Smith</MenuItem>
                <MenuItem value="2">Sarah Johnson</MenuItem>
                <MenuItem value="3">Michael Chen</MenuItem>
              </Select>
            </FormControl>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={onGenerate}
          variant="contained"
          startIcon={<Download size={18} />}
        >
          Generate Report
        </Button>
      </DialogActions>
    </Dialog>
  );
};